import React from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './Edition3Page.module.css';

const speakers = [
  {
    nom: 'Iman Deschâtres',
    titre: 'Founder de Deptax',
    image: '/assets/images/speaker-iman.png',
    linkedin: 'https://www.linkedin.com/in/iman-desch%C3%A2tres-6b59b54/',
  },
  {
    nom: 'Sandrine Le Cam',
    titre: 'CMO associée de Data Enso',
    image: 'https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/69a6d2287dd76725383e0c0e_Blanc%20Photographique%20e%CC%81le%CC%81gant%20Post%20Instagram%20(18).png',
    linkedin: 'https://www.linkedin.com/in/benjaboyer/',
  },
  {
    nom: 'Amal Dopchie',
    titre: 'Directrice Practice DCX chez Rhapsodies Conseil',
    image: '/assets/images/speaker-amal.png',
    linkedin: 'https://www.linkedin.com/in/amaldopchie/',
  },
  {
    nom: 'Rudy Abitbol',
    titre: 'B2B Commerce Advisor chez Human After All',
    image: 'https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/69343efd7426887369b80b6d_Blanc%20Photographique%20e%CC%81le%CC%81gant%20Post%20Instagram%20(16).png',
    linkedin: 'https://www.linkedin.com/in/rudyabitbol/',
  },
  {
    nom: 'Xaviere Tallent',
    titre: 'Global Offer Leader for Commerce, Agentic Commerce & Sales chez Capgemini',
    image: '/assets/images/speaker-xaviere.png',
    linkedin: 'https://www.linkedin.com/in/tallent/',
  },
  {
    nom: 'Emmanuelle Evette',
    titre: 'Directrice Conseil - Head of eCommerce chez VML Consulting',
    image: '/assets/images/speaker-emmanuelle.png',
    linkedin: 'https://www.linkedin.com/in/emmanuelle-evette-21b71657/',
  },
];

const Edition3Page: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Brands 2 Buyers - Edition 3</title>
        <meta property="og:title" content="Brands 2 Buyers - Edition 3" />
        <meta name="twitter:title" content="Brands 2 Buyers - Edition 3" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      {/* Hero — BD image background with dark overlay */}
      <section className={styles.heroImageBg}>
        <div className={styles.heroContainer}>
          <h1 className={styles.heroBrands2Buyers}>BRANDS2BUYERS</h1>
          <div className={styles.heroEdition}>Édition 3</div>
        </div>
      </section>

      {/* Description under hero — white bg */}
      <section className={styles.heroDescSection}>
        <div className={styles.heroDescContainer}>
          <h1 className={styles.heroTitle}>Bienvenue à Brands2Buyers édition 3 !</h1>
          <div className={styles.heroDesc}>
            Une soirée dédiée aux échanges directs, aux retours d'expérience concrets et aux
            meilleures pratiques pour fluidifier les collaborations B2B.
          </div>
        </div>
      </section>

      {/* Programme — white background, black text */}
      <section className={styles.programmeSection}>
        <div className={styles.programmeSectionInner}>
          <h1 className={styles.sectionTitle}>AU PROGRAMME</h1>

          <div className={styles.programmeText}>
            <span className={styles.heureBlue}>18H00 </span>
            <span className={styles.heureBlue}> <br /></span>
            <span className={styles.eventName}>ON LANCE LES HOSTILITÉS ! </span><br />
            Champagne, playlist 90's et premiers échanges pour lancer la soirée !<br /><br />

            <span className={styles.heureBlue}>19H00 : <br /></span>
            <span className={styles.eventName}>Le p'tit bac des 90's</span><strong><br />
              Un p'tit bac surprise pour briser la glace et réveiller les souvenirs<br />
            </strong>

            <span className={styles.heureBlue}><strong><br />19H10 </strong></span>
            <span className={styles.heureBlue}><strong> <br /></strong></span>
            <span className={styles.eventName}><strong>Début de la conférence</strong></span><strong><br />
              Introduction et objectifs de l'événement<br /><br />
            </strong>

            <span className={styles.heureBlue}><strong>19H20 : <br /></strong></span>
            <span className={styles.eventName}><strong>Keynote d'ouverture</strong></span><br />
            <span className={styles.intervenants}><strong>Rudy Abitbol - Adrien Naeem - Laetitia Lamari</strong></span><br />
            U<strong>n p'tit bac surprise pour briser la glace et réveiller les souvenirs</strong><br /><br />

            <span className={styles.heureBlue}>19H30 <br /></span>
            <span className={styles.eventName}>Data : le nerf de la guerre</span><br />
            <span className={styles.intervenants}><strong>Soumaya Hamzaoui - Adrien Naeem - Laetitia Lamari</strong></span><strong><br />
              Pourquoi tout commence (et finit) par la donnée.
            </strong><br /> <br />

            <span className={styles.heureBlue}>19H40 : <br /></span>
            <span className={styles.eventName}>TABLE RONDE #1 Souveraineté &amp; qualité de la data</span><br />
            <span className={styles.intervenants}>Jose Badana - Sandrine Le Cam - Adrien Naeem - Laetitia Lamari</span><br />
            Autodistribution&amp; Data Enso : entre performance, contrôle et souveraineté de la data<br /><br />

            <span className={styles.heureBlue}>20H00 </span> <br />
            <span className={styles.eventName}>Data &amp; IA : du potentiel au ROI</span><br />
            <span className={styles.intervenants}>Aurore Gusdorf - Adrien Naeem - Laetitia Lamari</span><br />
            Comment l'IA et l'agentique sont au service des organisations<br /><br />
          </div>

          <div className={styles.programmeText}>
            <span className={styles.heureBlue}>20H30 </span> <br />
            <span className={styles.eventName}>LE MOMENT NETWORKING</span><br />
            Échanges, connexions et énergie collective pour finir en beauté !<br />
          </div>
        </div>
      </section>

      {/* Speakers — background image */}
      <section className={styles.speakersSection}>
        <div className={styles.speakersSectionInner}>
          {/* Colonne gauche : illustration d'ambiance */}
          <div className={styles.speakersLeftCol}>
            <img
              src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/67101d4ea219e41ad2af2784_AlbedoBase_XL_90s_style_2_men_talk_on_stage_in_front_of_an_aud_3.jpg"
              alt="Ambiance événement B2B"
              className={styles.speakersIllustration}
              sizes="(max-width: 479px) 100vw, 462px"
              srcSet="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/67101d4ea219e41ad2af2784_AlbedoBase_XL_90s_style_2_men_talk_on_stage_in_front_of_an_aud_3-p-500.jpg 500w, https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/67101d4ea219e41ad2af2784_AlbedoBase_XL_90s_style_2_men_talk_on_stage_in_front_of_an_aud_3-p-800.jpg 800w, https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/67101d4ea219e41ad2af2784_AlbedoBase_XL_90s_style_2_men_talk_on_stage_in_front_of_an_aud_3-p-1080.jpg 1080w, https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/67101d4ea219e41ad2af2784_AlbedoBase_XL_90s_style_2_men_talk_on_stage_in_front_of_an_aud_3.jpg 1368w"
            />
          </div>
          {/* Colonne droite : titre + grille speakers */}
          <div className={styles.speakersRightCol}>
            <h2 className={styles.speakersH2}>
              DES INVITÉS B2B AMBITIEUX :
            </h2>
            <div className={styles.speakersGrid}>
              {speakers.map((speaker, index) => (
                <div key={index} className={styles.speakerCard}>
                  <a href={speaker.linkedin} target="_blank" rel="noreferrer">
                    <div className={styles.speakerImageWrapper}>
                      <img
                        src={speaker.image}
                        alt={speaker.nom}
                        className={styles.speakerImage}
                        loading="lazy"
                      />
                    </div>
                  </a>
                  <div className={styles.speakerInfo}>
                    <p className={styles.speakerNom}><strong>{speaker.nom}</strong></p>
                    <p className={styles.speakerTitre}><strong>{speaker.titre}</strong></p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp — violet-b2b background */}
      <section className={styles.whatsappSection}>
        <div className={styles.whatsappInner}>
          <div className={styles.whatsappTextBlock}>
            <h1 className={styles.whatsappTitle}>Rejoignez le groupe WhatsApp Brands2Buyers !</h1>
            <div className={styles.whatsappText}>
              Un espace réservé aux participants pour :<br />
              • partager vos actualités et vos besoins<br />
              • rester en contact avec les marques et partenaires présents<br />
              • retrouver les ressources et informations clés de l'évènement<br />
              • être informé(e) en avant-première des prochaines éditions.
            </div>
            <a
              href="https://chat.whatsapp.com/KN6a2NAqGUB6pHnjqvFqin"
              target="_blank"
              rel="noreferrer"
              className={styles.whatsappBtn}
            >
              Rejoindre le groupe !
            </a>
          </div>
          <div className={styles.whatsappImage}>
            <img
              src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/670f9cc9a04d7cedcfa9e171_AlbedoBase_XL_90s_mobile_social_media_0.jpg"
              loading="lazy"
              alt="WhatsApp"
            />
          </div>
        </div>
      </section>

      {/* Communauté — rose-b2b background */}
      <section className={styles.communauteSection}>
        <div className={styles.communauteInner}>
          <h1 className={styles.communauteTitle}>Rejoignez la communauté !</h1>
          <div className={styles.communauteText}>
            Nous avons secoué l'e-commerce et fédéré une vraie tribu : une communauté de milliers
            de passionnés qui suivent chaque jour l'e-commerce qui bouge. Rejoignez nos groupes
            pour papoter tendances, partager vos galères, vos victoires… et ne plus jamais
            brainstormer tout seul !
          </div>
          <div className={styles.communauteImages}>
            <a href="https://chat.whatsapp.com/K0EV7FJH29BEMYxQFgO9e3" target="_blank" rel="noreferrer">
              <img
                src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/693458f4c9ec48264e94ebe7_684bea8c000512a9d85c56d3_1.jpg"
                loading="lazy"
                alt="Communauté WhatsApp 1"
              />
            </a>
            <a href="https://chat.whatsapp.com/IrSzW75IfsUFIAKnTbGYPA" target="_blank" rel="noreferrer">
              <img
                src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/693458f48b0d508ece27359e_684bea8c4604b4f162f6185c_2.jpg"
                loading="lazy"
                alt="Communauté WhatsApp 2"
              />
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Edition3Page;
